function CapitalizeEachWord(text) {
if (!text) return ''; // Handle empty or null strings

return text
.split(' ') // Split the string into an array of words
.map(word => {
    if (word.length === 0) {
    return ''; // Handle empty words if any
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); // Capitalize first letter, lowercase the rest
})
.join(' '); // Join the words back into a single string;

}

export {
    CapitalizeEachWord
}